import React, { useEffect } from "react";
import { useNavigate } from "react-router";
import { Container } from "react-bootstrap";
import Header from "../../components/Header";
import { FaUserTimes } from "react-icons/fa";
import { useAuthContext } from "../../utils/AuthContext";
import { Button } from "react-bootstrap";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useEventContext } from "../../utils/EventContext";

const UpdateRegistrationError = () => {
  const navigate = useNavigate();
  const event = useEventContext();

  const app = useAuthContext();
  useEffect(() => {
    app.initAuthPublicPage();
  });

  return (
    <Container className="Student">
      <Header></Header>
      <Button
        onClick={() => {
          navigate(`/?eventKey=${event.eventConfig.EventKey}`);
        }}
        style={{
          margin: "1",
          backgroundColor: "#F5F5F5",
          borderRadius: 4,
        }}
      >
        <ArrowBackIcon style={{ color: "black" }} />
        <span
          style={{
            margin: "5px",
            color: "#060606",
          }}
        >
          Back
        </span>
      </Button>
      <div style={{ textAlign: "center" }}>
        <FaUserTimes style={{ fontSize: "64px", color: "#d9534f" }} />
        <h1 style={{ fontSize: "24px", marginTop: "20px" }}>Oh No!</h1>
        <h4 style={{ fontSize: "18px", marginTop: "10px" }}>
          There was an error updating this student's registration!
        </h4>
        <h4>Please try again!</h4>
      </div>
    </Container>
  );
};

export default UpdateRegistrationError;
